/**
 * Busy state for buttons - the house pattern for "working..." affordance.
 *
 *   g.busy(btn, true)   - disable + spinner (keeps the button's width)
 *   g.busy(btn, false)  - restore the original content + enabled state
 *
 * `target` is a button/element or a selector. Turning busy on twice is a
 * no-op; turning it off restores exactly what was there before. Used by
 * former's submit pipeline; free for app code too.
 */
export function busy(target, on = true) {
	const el = typeof target === 'string' ? document.querySelector(target) : target;
	if (!el) return;
	if (on) {
		if (el._busy) return;
		el._busy = { html: el.innerHTML, disabled: el.disabled };
		// Freeze the current width so the spinner does not reflow the layout.
		el.style.width = el.getBoundingClientRect().width + 'px';
		el.disabled = true;
		el.setAttribute('aria-busy', 'true');
		el.innerHTML = '<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>';
	} else {
		if (!el._busy) return;
		el.innerHTML = el._busy.html;
		el.disabled = el._busy.disabled;
		el.style.width = '';
		el.removeAttribute('aria-busy');
		delete el._busy;
	}
}
